<template >
  <el-dialog lock-scroll :visible.sync="dialogVisible_box" :show-close="false" custom-class="maxss" width="1090px"
    top="1vh" style="overflow: hidden;">
    <div class="whole" ref="whole">
      <div style="width: 360px;margin-left: 10px; position: fixed;">
        <div style="width: 360px;">
          <div style="height: 180px; border: 1px solid #D9D9D9; border-radius: 5px;background: #fff;">
            <el-form ref="form" label-width="60px" size="mini">
              <el-form-item   label="姓名" style="margin-top: 20px; font-size: 12px; padding:0px 10px 0px 10px">
                <el-input   v-model="sizeForm" placeholder="请选择"></el-input>
              </el-form-item>
              <el-form-item label="身份证号码" style="margin-top: 20px; font-size: 12px; padding: 0px 10px 0px 10px">
                <el-input  v-model="sizeForm" placeholder="请填写（必须填）"></el-input>
              </el-form-item>
              <el-form-item label="身份证地址" style="margin-top: 20px; font-size: 12px; padding: 0px 10px 0px 10px">
                <el-input  v-model="sizeForm" placeholder="请填写（必须填）"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="Completion_status">
            <div>
              <span>籍贯</span>
              <input type="text">
            </div>
            <div>
              <span>出生日期</span>
              <input type="text">
            </div>
            <div>
              <span>手机号</span>
              <input type="text">
            </div>
            <div>
              <span>紧急联系人</span>
              <input type="text">
            </div>
            <div>
              <span>紧急联系人手机号</span>
              <input type="text">
            </div>
          </div>
          <!-- 内容区域 -->
          <div class="content">
            <div class="content_header">
              <div>
                <span>所属公司</span>
                <input type="text">
              </div>
              <div>
                <span>所属部门</span>
                <input type="text">
              </div>
              <div>
                <span>结算部门</span>
                <input type="text">
              </div>
              <div>
                <span>所属工种</span>
                <input type="text">
              </div>

              <!-- <div>
              <span>工作状态</span>
              <input type="text">
            </div>
            <div>
              <span>社保状态</span>
              <input type="text">
            </div>
            <div>
              <span>入职时间</span>
              <input type="text">
            </div>
            <div>
              <span>离职时间</span>
              <input type="text">
            </div>
            <div>
                <span>合同到期</span>
                <input type="text">
              </div> -->
            </div>
            <div class="content_center">
              <span class="personal_ability">个人能力</span>
              <label><input type="checkbox" checked> 项目经理</label>
              <label><input type="checkbox" checked> 渲染</label>
              <label><input type="checkbox" checked> 模型</label>
              <label><input type="checkbox" checked> 市场</label>
            </div>
            <div class="content_header">
              <div>
                <span>工作状态</span>
                <input type="text">
              </div>
              <div>
                <span>社保状态</span>
                <input type="text">
              </div>
              <div>
                <span>入职时间</span>
                <input type="text">
              </div>
              <div>
                <span>离职时间</span>
                <input type="text">
              </div>
              <div>
                <span>合同到期</span>
                <input type="text">
              </div>
            </div>
          </div>
          <div class="fingerprint">
            <span>
              指纹密码:<input type="text">
            </span>
          </div>
        </div>
      </div>
      <div style="width: 690px;margin-left:380px">
        <div class="offside">
          <div class="tabs">
          </div>
          <div class="cloneEvt">
            <span>保存</span>
            <span>删除</span>
          </div>
        </div>
        <div class="arrangement" ref="arrangement" id="tab1Content">
          <div>
            <el-upload class="upload-demo" drag action="https://jsonplaceholder.typicode.com/posts/" multiple>
              <span>身份证正面</span>
            </el-upload>
          </div>
          <div>
            <el-upload class="upload-demo" drag action="https://jsonplaceholder.typicode.com/posts/" multiple>
              <span>身份证背面</span>
            </el-upload>
          </div>
        </div>

        <div class="Mapping_quantity" ref="Mapping_quantity" id="tab3Content">
          <div class="box_header">
            <div class="box">
              <span>1</span>
              <div>
                <span>总成本</span>
                <span>120%</span>
              </div>
            </div>
            <div class="box">
              <span>1</span>
              <div>
                <span>总成本</span>
                <span>120%</span>
              </div>
            </div>
            <div class="box">
              <span>1</span>
              <div>
                <span>总成本</span>
                <span>120%</span>
              </div>
            </div>
            <div class="box">
              <span>1</span>
              <div>
                <span>总成本</span>
                <span>120%</span>
              </div>
            </div>
            <div class="box">
              <span>1</span>
              <div>
                <span>总成本</span>
                <span>120%</span>
              </div>
            </div>
          </div>

          <div class="fromEvt">
            <el-table :data="tableData" stripe style="width: 100%" height="523px">
              <el-table-column prop="zip" label="日期" width="88">
              </el-table-column>
              <el-table-column prop="zip" label="1" width="48">
              </el-table-column>
              <el-table-column prop="zip" label="2" width="48">
              </el-table-column>
               <el-table-column prop="zip" label="3" width="48">
                </el-table-column>
                 <el-table-column prop="zip" label="4" width="48">
                </el-table-column>
                 <el-table-column prop="zip" label="5" width="48">
                </el-table-column>
                 <el-table-column prop="zip" label="6" width="48">
                </el-table-column>
                 <el-table-column prop="zip" label="7" width="48">
              </el-table-column>
               <el-table-column prop="zip" label="8" width="48">
                </el-table-column>
                 <el-table-column prop="zip" label="9" width="48">
                </el-table-column>
                 <el-table-column prop="zip" label="10" width="48">
                </el-table-column>
                 <el-table-column prop="zip" label="11" width="48">
                </el-table-column>
                 <el-table-column prop="zip" label="12">
                  </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>



<script>
export default {
  props: {
    dialogFormVisible: Boolean
  },
  data() {
    return {
      dialogVisible_box: false,
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      value: '',
      tableData: [{
        date: '2016-05-02',
        name: '王小虎',
        province: '上海',
        city123: '普陀区',
        address: '上海市普',
        zip: 200,
      }, {
        date: '2016-05-02',
        name: '王小虎',
        province: '上海',
        city12: '普陀区',
        address: '上海市普',
        zip: 200
      },
    {
        date: '2016-05-02',
        name: '王小虎',
        province: '上海',
        city12: '普陀区',
        address: '上海市普',
        zip: 200
      },],
      checkList: ['选中且禁用', '复选框 A'],
      sizeForm:null,
    }
  },
  mounted() {

  },
  methods: {
    openDialog_box() {
      this.dialogVisible_box = true;
    },

  },

}
</script>

<style scoped  lang="less">
.el-dialog {
  background: #f00 !important;
  overflow: hidden;
}

.whole {
  width: 1090px;
  height: 948px;
  display: flex;
  overflow-y: scroll !important;
}

/* 设置滚动条宽度 */
.whole::-webkit-scrollbar {
  width: 8px;
  /* 调整滚动条宽度 */
}

/* 设置滚动条的轨道背景色 */
.whole::-webkit-scrollbar-track {}

/* 设置滚动条手柄（拖动条）颜色 */
.whole::-webkit-scrollbar-thumb {
  background-color: #888;
}

//图量安排
.arrangement {
  width: 100%;
  height: 220px;
  margin-top: 36px;
  background: #fff;
  justify-content: space-evenly;
  align-items: center;
  border-radius: 5px;
  div {
    width: 330px;
    height: 180px;
  }

  /deep/.el-upload-dragger {
    width: 330px;
    line-height: 180px;
    color: #979797;
    background: #F3F3F3;
    border: none;
  }
}

//成图全部图片
.Mapping_quantity {
  width: 100%;
  height: 630px;
  margin-top: 10px;
  display: inline-block;
  background: #fff;
  border-radius: 5px;
  .box {
    height: 70px;
    width: 120px;
    border: 1px solid;
    border-radius: 3px;
    background: #B8B7B7;

    span {
      text-align: left;
      display: block;
      margin-left: 6px;
    }

    div {
      margin-top: 29px;
      display: flex;
      justify-content: space-between;
      margin-right: 13px;
    }
  }
}

.box_header {
  display: flex;
  justify-content: space-between;
  width: 93%;
  border: 1px solid;
  margin: 20px auto 0 auto;
  color: #fff;
}


.Completion_status {
  height: 227px;
  margin-top: 10px;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  background: #fff;
  border-radius: 5px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  div {
    width: 150px;
    height: 50px;
    margin-left: 10px;
    margin-right: 10px;
    display: flex;
    flex-direction: column;
    margin-top: 15px;
  }

  span {
    text-align: left;
    font-size: 12px;
  }

  input {
    margin-top: 6px;
    display: inline-flex;
    align-items: center;
    border-radius: 5px;
    border: 0.5px solid #D9D9D9;
    height: 30px;
    outline: none;
    text-indent: 1em;
  }
}

//内容区域
.content {
  height: 400px;
  margin-top: 10px;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  background: #fff;

  .content_header {
    width: 98%;
    height: 152px;
    display: flex;
    flex-wrap: wrap;

    div {
      width: 150px;
      height: 50px;
      margin-left: 10px;
      margin-right: 10px;
      display: flex;
      flex-direction: column;
      margin-top: 15px;
    }

    span {
      text-align: left;
      font-size: 12px;
    }

    input {
      margin-top: 6px;
      display: inline-flex;
      align-items: center;
      border-radius: 5px;
      border: 0.5px solid #D9D9D9;
      height: 30px;
      outline: none;
      text-indent: 1em;
    }
  }

  .content_center {
    width: 98%;
    height: 37px;
    line-height: 37px;
    display: flex;
    padding-left: 10px;

    label {
      display: flex;
      margin-left: 10px;

      input {
        margin-top: 7px;
      }
    }
  }

}

.fingerprint {
  height: 62px;
  margin-top: 10px;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  background: #fff;
  font-size: 12px;

  span {
    display: flex;
    width: 340px;
    height: 50px;
    align-items: center;
    flex-shrink: 0;
    border-radius: 5px;
    border: 0.5px solid #D9D9D9;
    margin: 5px auto;
    text-indent: 1em;
  }

  input {
    border: none;
    outline: none;
    font-size: 12px;
  }
}

//表单
.fromEvt {
  width: 98%;
  margin: 55px auto 0 auto;
}



/deep/.el-input--mini .el-input__inner {
  height: 30px;
}

/deep/.el-form-item__label {
  padding: 0px;
  font-size: 12px;
  color: #333;
}

/deep/.el-input {
  width: 270px;
  margin-left: 7px;
}

.mins {
  /deep/.el-input--suffix {
    width: 89px !important;
    margin-left: 55px;
  }
}

.maxs {
  width: 188px !important;
}

.text_box {
  width: 282px;
  height: 73px;
  border-radius: 5px;
  border: 0.5px solid #D9D9D9;
}

/deep/.el-form-item {
  margin-bottom: 10px;
}

.text_one {
  /deep/.el-form-item__content {
    margin-bottom: -10px;
  }
}

/deep/.el-dialog__header {
  background: #D9D9D9;
}

/deep/.el-dialog__body {
  background: #D9D9D9;
}

//右侧图量样式
.tabs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;

  span {

    cursor: pointer;
    height: 24px;
    padding: 5px 10px;
    font-size: 12px;
  }
}

.tabs span:nth-child(1) {
  border-radius: 3px 0px 0px 3px;
}

.tabs span:nth-last-of-type(1) {
  border-radius: 0px 3px 3px 0px;
}

.tabs span.active {
  background-color: #3383EA;
  color: #fff;
}

.tab-content {
  display: none;
  padding: 20px;
}

.tab-content.active {
  display: block;
}

//右侧样式
.offside {
  height: 24px;
  display: flex;
  justify-content: space-between;
  position: fixed;
  z-index: 11111;
  background: #D9D9D9;
  width: 690px;
}

// 删除和保存的样式
.cloneEvt {
  display: flex;
  margin-left: 240px;

  span:nth-child(1) {
    display: flex;
    width: 70px;
    padding: 5px 23px;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    background: #3383EA;
    font-size: 12px;
    color: #fff;
    margin-right: 20px;
  }

  span:nth-child(2) {
    display: flex;
    width: 70px;
    padding: 5px 23px;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    background: #979797;
    font-size: 12px;
    color: #fff;
  }
}

/deep/.el-table--fit {
  margin-top: -40px !important;
}

/deep/.el-table__body-wrapper {
  overflow: hidden !important;
}

/deep/.el-table .el-table__cell {
  height: 30px !important;
  padding: 0px !important;
}

/deep/.el-table th.el-table__cell>.cell:nth-child(1) {
  margin-top: 20.5px;
}

/deep/.el-table th.el-table__cell {
  background: #fff;
}

/deep/.el-table__header-wrapper {
  background: #fff !important;
}

//成图
.image-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.mapping {
  width: 220px;
  height: 120px;
  height: 180px;
  background: #F3F3F3;
  margin-top: 20px;
  margin-bottom: 17px;

  img {
    width: 100%;
    max-width: 198px;
    height: 120px;
    display: block;
    margin: 30px auto;
    background: #fff;
    object-fit: contain;
  }
}




.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.amount_to {
  position: relative;
  top: 55px;
  z-index: 111;
  width: 100%;
  height: 50px;
  display: flex;

  div {
    width: 68px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  div:nth-child(1) {
    margin-left: 10px;
  }

  div:nth-child(2) {
    margin-left: 80px;
  }

  div:nth-child(3) {
    margin-left: 20px;
  }

  div:nth-child(4) {
    margin-left: 10px;
  }

  div:nth-child(5) {
    margin-left: 10px;
  }

  div:nth-child(6) {
    margin-left: 25px;
  }

  div:nth-child(7) {
    margin-left: 10px;
  }

  div:nth-child(8) {
    margin-left: 10px;
  }
}



</style>



// WEBPACK FOOTER //
// src/components/details.vue